import { ReactElement } from 'react';
import {
  ContainerHeader, EnvironmentCardIcon, EnvironmentInfo, ErrorStatusCard, HeaderTitleContent, IconButton, Title,
} from '../styles';
import { BackRCIcon, Building07Icon } from 'icons';
import { StatusCard } from '../../StatusCard';
import Skeleton from 'react-loading-skeleton';
import { colors } from '~/styles/remoteControlColors';
import { shadows } from '~/styles/remoteControlShadows';
import { StatusCardOptions } from '../types';

interface HeaderMachineProps {
  readonly name: string;
  readonly environmentName: string;
  readonly loading: boolean;
  readonly statusCardOptions: StatusCardOptions;
  readonly error: boolean;
  readonly onClickBackButton: () => void;
}

function HeaderMachineLoading(): ReactElement {
  return (
    <ContainerHeader style={{ backgroundColor: colors.White, gap: '12px', boxShadow: shadows.shadow01 }} loading>
      <Skeleton height="12px" />
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        <Skeleton width="24px" height="24px" borderRadius={8} />
        <Skeleton height="12px" width="300px" style={{ marginTop: '10px' }} />
      </div>
      <div style={{ display: 'flex', gap: '2px' }}>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}
        >
          <Skeleton width="76px" height="12px" borderRadius={8} />
          <Skeleton width="36px" height="36px" borderRadius={8} />
        </div>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}
        >
          <Skeleton width="76px" height="12px" borderRadius={8} />
          <Skeleton width="36px" height="36px" borderRadius={8} />
        </div>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}
        >
          <Skeleton width="76px" height="12px" borderRadius={8} />
          <Skeleton width="36px" height="36px" borderRadius={8} />
        </div>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}
        >
          <Skeleton width="76px" height="12px" borderRadius={8} />
          <Skeleton width="36px" height="36px" borderRadius={8} />
        </div>
      </div>
    </ContainerHeader>
  );
}

export function HeaderMachine({
  environmentName,
  name,
  loading,
  error,
  statusCardOptions,
  onClickBackButton,
}: HeaderMachineProps): ReactElement {
  if (loading) {
    return (<HeaderMachineLoading />);
  }

  return (
    <>
      <ContainerHeader>
        <HeaderTitleContent>
          <IconButton
            type="button"
            onClick={onClickBackButton}
            style={{ position: 'absolute', left: 0 }}
          >
            <BackRCIcon size="18" />
          </IconButton>
          <Title>{name}</Title>
        </HeaderTitleContent>
        <EnvironmentInfo>
          <EnvironmentCardIcon>
            <Building07Icon size="16" />
          </EnvironmentCardIcon>
          <h2>{environmentName}</h2>
        </EnvironmentInfo>
        {error ? (
          <ErrorStatusCard />
        ) : (
          <StatusCard
            isConnected={statusCardOptions.connection}
            operation={statusCardOptions.operation}
            status={statusCardOptions.status}
            healthStatus={statusCardOptions.healthStatus}
          />
        )}
      </ContainerHeader>
    </>
  );
}
